import { render, staticRenderFns } from "./WorkExpansionPanelHeader.vue?vue&type=template&id=3d086786&scoped=true"
import script from "./WorkExpansionPanelHeader.vue?vue&type=script&lang=js"
export * from "./WorkExpansionPanelHeader.vue?vue&type=script&lang=js"
import style0 from "./WorkExpansionPanelHeader.vue?vue&type=style&index=0&id=3d086786&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d086786",
  null
  
)

export default component.exports